// My Purchases prepares the generator asset before opening AI Studio and hands it over in
// the studio URL, so the studio loads it without asking which file to open. The values come
// from the URL, so each one is validated; the server still checks ownership of the asset.
const VIEWER_FORMATS = ['glb', 'gltf', 'fbx', 'obj', 'stl']
const DIGITS = /^\d+$/

export const buildPreparedAcquiredModelQuery = ({ assetId, format, fileSize }) => {
  const params = new URLSearchParams({ asset_id: String(assetId), format })
  if (fileSize != null) params.set('file_size', String(fileSize))

  return `?${params.toString()}`
}

export const parsePreparedAcquiredModelQuery = (search) => {
  const params = new URLSearchParams(search ?? '')
  const assetId = params.get('asset_id') ?? ''
  const format = (params.get('format') ?? '').toLowerCase()
  const fileSize = params.get('file_size') ?? ''

  if (!DIGITS.test(assetId) || !VIEWER_FORMATS.includes(format)) return null

  return {
    assetId: Number(assetId),
    format,
    fileSize: DIGITS.test(fileSize) ? Number(fileSize) : null,
  }
}
